import { admGraphqlRequest } from 'core/utils/backend-service';
import { OnetimeDeviceImportAPI } from './onetime-device-import.api';
import { getOnetimeDeviceImportQuery, triggerOnetimeDeviceImportMutation } from './onetime-device-import.queries';

export const getOnetimeDeviceImport = (): Promise<OnetimeDeviceImportAPI> =>
    admGraphqlRequest(getOnetimeDeviceImportQuery()).then((result) => result.data.onetimeDeviceImport);

export const triggerOnetimeDeviceImport = (): Promise<void> =>
    admGraphqlRequest(triggerOnetimeDeviceImportMutation()).then((result) => result.data.triggerOnetimeDeviceImport);
